import React from 'react';
import DestinationTemplate from '../../components/DestinationTemplate';

const DubaiPage = () => {
  return <DestinationTemplate destinationId="dubai" />;
};

export default DubaiPage;
